import { colors, DateRange, TagProps } from 'bold-ui'
import { DadosCidadaoVisualizarAtendimentoModel } from 'components/atendimento/model'
import { PageParams, StatusAssinatura, TipoAtendimentoProfissional } from 'graphql/types.generated'
import { formatDateAndHoursMinutes } from 'util/date/formatDate'
import { metaPath } from 'util/metaPath'

export const MESES_PERIODO_ASSINATURA_DIGITAL = 3
export const MSG_ERRO_PERIODO_INCOMPLETO =
  'É necessário preencher ambos os campos de período para que a listagem seja filtrada corretamente.'

export interface AssinaturaEletronicaAtendTableRowModel {
  id: ID
  dataRegistro: number
  tipoAtendimento: TipoAtendimentoProfissional
  cidadao: DadosCidadaoVisualizarAtendimentoModel | undefined
  horarioAssinatura?: number
  statusAssinatura?: StatusAssinatura
  codigoUnicoRegistro: string
  isAtendimentoRecente: boolean
  hasObservacao: boolean
  isAtendimentoAssinado?: boolean
  isObservacaoNaoFinalizada: boolean
}

export interface GerarAtendimentoDigitalInput {
  atendimentoProfissionalId: ID
}

export interface BaixarAtendimentoDigitalInput {
  atendimentoProfissionalId: ID
}

export enum CriterioExibicaoAtendimento {
  TODOS_OS_ATENDIMENTOS = 'TODOS_OS_ATENDIMENTOS',
  ATENDIMENTOS_SEM_ASSINATURA = 'ATENDIMENTOS_SEM_ASSINATURA',
  ATENDIMENTOS_COM_ASSINATURA = 'ATENDIMENTOS_COM_ASSINATURA',
}

export interface AssinaturaEletronicaAtendTableFilterModel {
  periodo?: DateRange
  criterioExibicao?: CriterioExibicaoAtendimento
  pageParams: PageParams
}

interface StatusAssinaturaTagModel extends Pick<TagProps, 'type' | 'icon'> {
  descricao: string
  color: string
  backgroundColor: string
}

export const statusAssinaturaAtendimentoRecord = (
  dataHoraAssinatura?: number
): Record<StatusAssinatura | 'NAO_ASSINADO', StatusAssinaturaTagModel> => {
  return {
    [StatusAssinatura.ASSINADO]: {
      type: 'success',
      icon: 'checkCircleFilled',
      color: colors.green.c40,
      backgroundColor: colors.green.c90,
      descricao: `Assinado em ${formatDateAndHoursMinutes(dataHoraAssinatura)}`,
    },
    [StatusAssinatura.ERRO_ASSINATURA]: {
      type: 'danger',
      icon: 'banOutline',
      color: colors.red.c40,
      backgroundColor: colors.red.c90,
      descricao: 'Erro na assinatura',
    },
    NAO_ASSINADO: {
      type: 'alert',
      icon: 'exclamationTriangleFilled',
      color: colors.orange.c40,
      backgroundColor: colors.orange.c90,
      descricao: 'Aguardando assinatura',
    },
  }
}

export const metaFilterAssinaturaEletronica = metaPath<AssinaturaEletronicaAtendTableFilterModel>()
